import type { Template } from "@/types";

export const LA_04_H0_V4: Template[] = [
{
    id: "la-04-h0v4-01",
    name: "LA 01 - H0V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h0_v4_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 60, y: 98, width: 251, height: 351, rotation: 0, imageRotation: 0 },
            { id: "2", x: 319, y: 98, width: 251, height: 351, rotation: 0, imageRotation: 0 },
            { id: "3", x: 577, y: 98, width: 251, height: 351, rotation: 0, imageRotation: 0 },
            { id: "4", x: 893, y: 27, width: 315, height: 420, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h0v4-02",
    name: "LA 02 - H0V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h0_v4_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 55, y: 39, width: 286, height: 397, rotation: 0, imageRotation: 0 },
            { id: "2", x: 349, y: 39, width: 286, height: 397, rotation: 0, imageRotation: 0 },
            { id: "3", x: 642, y: 39, width: 286, height: 397, rotation: 0, imageRotation: 0 },
            { id: "4", x: 935, y: 39, width: 286, height: 397, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h0v4-03",
    name: "LA 03 - H0V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h0_v4_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 54, y: 48, width: 261, height: 380, rotation: 0, imageRotation: 0 },
            { id: "2", x: 322, y: 48, width: 261, height: 380, rotation: 0, imageRotation: 0 },
            { id: "3", x: 691, y: 48, width: 261, height: 380, rotation: 0, imageRotation: 0 },
            { id: "4", x: 959, y: 48, width: 261, height: 380, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h0v4-04",
    name: "LA 04 - H0V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h0_v4_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 0, width: 355, height: 476, rotation: 0, imageRotation: 0 },
            { id: "2", x: 448, y: 65, width: 240, height: 351, rotation: 0, imageRotation: 0 },
            { id: "3", x: 695, y: 65, width: 240, height: 351, rotation: 0, imageRotation: 0 },
            { id: "4", x: 943, y: 65, width: 240, height: 351, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h0v4-05",
    name: "LA 05 - H0V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h0_v4_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 86, y: 38, width: 286, height: 402, rotation: 0, imageRotation: 0 },
            { id: "2", x: 380, y: 38, width: 158, height: 198, rotation: 0, imageRotation: 0 },
            { id: "3", x: 380, y: 243, width: 158, height: 198, rotation: 0, imageRotation: 0 },
            { id: "4", x: 804, y: 34, width: 303, height: 402, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h0v4-06",
    name: "LA 06 - H0V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h0_v4_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 41, y: 33, width: 307, height: 409, rotation: 0, imageRotation: 0 },
            { id: "2", x: 510, y: 167, width: 208, height: 276, rotation: 0, imageRotation: 0 },
            { id: "3", x: 726, y: 167, width: 208, height: 276, rotation: 0, imageRotation: 0 },
            { id: "4", x: 941, y: 167, width: 208, height: 276, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h0v4-07",
    name: "LA 07 - H0V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h0_v4_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 86, y: 38, width: 157, height: 197, rotation: 0, imageRotation: 0 },
            { id: "2", x: 86, y: 243, width: 157, height: 197, rotation: 0, imageRotation: 0 },
            { id: "3", x: 251, y: 38, width: 300, height: 402, rotation: 0, imageRotation: 0 },
            { id: "4", x: 802, y: 33, width: 307, height: 402, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h0v4-08",
    name: "LA 08 - H0V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h0_v4_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 724, y: 38, width: 300, height: 402, rotation: 0, imageRotation: 0 },
            { id: "2", x: 165, y: 33, width: 307, height: 402, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1031, y: 38, width: 157, height: 197, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1031, y: 243, width: 157, height: 197, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h0v4-09",
    name: "LA 09 - H0V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h0_v4_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 87, y: 33, width: 298, height: 409, rotation: 0, imageRotation: 0 },
            { id: "2", x: 401, y: 79, width: 224, height: 317, rotation: 0, imageRotation: 0 },
            { id: "3", x: 648, y: 79, width: 224, height: 317, rotation: 0, imageRotation: 0 },
            { id: "4", x: 890, y: 33, width: 298, height: 409, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h0v4-10",
    name: "LA 10 - H0V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h0_v4_10.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 131, y: 100, width: 207, height: 276, rotation: 0, imageRotation: 0 },
            { id: "2", x: 346, y: 100, width: 206, height: 276, rotation: 0, imageRotation: 0 },
            { id: "3", x: 560, y: 100, width: 206, height: 276, rotation: 0, imageRotation: 0 },
            { id: "4", x: 936, y: 33, width: 298, height: 409, rotation: 0, imageRotation: 0 }
    ],
}
];